import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import 'moment-timezone';
import { GlobalConstants } from '../../../common/constants/global.constant';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {
  //If value is in Date formate it will formate it otherwise it will return the value as it is in "24hr"
  stringMdification(values: string, s1: any, s2: any): string {
    return (values.split(' '))
      .slice(s1, s2)
      .reduce((a, b) => {
        let temp = a + " ";
        return temp + b;
      });
  }
  addingDecoration(date: string) {
    let temp = date.split(' ')
    temp[1] += ','
    temp[2] += ' -'
    return temp.reduce((a, b) => { let temp = a + " "; return temp + b });
  }
  checkIfAm(time) {
    time = +time.split(':')[0]
    if (time < 12) {
      return 'AM'
    } else {
      return 'PM'
    }
  }
  transform(value: any, format: string): any {
    const abbreviation = GlobalConstants.ABBREVIATION;
    const timeZone_ = Intl.DateTimeFormat().resolvedOptions().timeZone;    
    var timeZoneInd=(timeZone_.indexOf('America') === -1 )? 1 : 0;
    if (format === "changeToLocalTimeZone"){
      try{
       //.format('MMM DD, YYYY - hh:mm A')+ " "+moment.tz(moment.tz.guess()).zoneAbbr();
        return timeZoneInd ?(moment(value).local().format('DD/MMM/yyyy - hh:mm A')):(moment(value).local().format('MMM/DD/yyyy - hh:mm A'))         
      }
      catch(err){
        return 'Invalid Date';  //When date is wrong or doesn't exist 
      }
    }
    else if (format === "changeToLocalTime"){
      try{
        //.format('MMM DD, YYYY - hh:mm A');
        return timeZoneInd ?(moment(value).local().format('DD/MMM/yyyy - hh:mm A')):(moment(value).local().format('MMM/DD/yyyy - hh:mm A'))         
      }
      catch(err){
        return 'Invalid Date';  //When date is wrong or doesn't exist 
      }
    }
    else if (format === "changeToLocalDisplay"){
      try{
        //.format('MMDDYYYY');
        return timeZoneInd ?(moment(value).local().format('DD/MMM/yyyy')):(moment(value).local().format('MMM/DD/yyyy'))         
      }
      catch(err){
        return 'Invalid Date';  //When date is wrong or doesn't exist 
      }
    }
    else if( format === "shortDateFormat"){ //IIT2-5802
      try{
        //.format('MMM DD, YYYY');
        return timeZoneInd ?(moment(value).local().format('DD/MMM/yyyy')):(moment(value).local().format('MMM/DD/yyyy'))         
      }
      catch(err){
        return 'Invalid Date';  //When date is wrong or doesn't exist 
      }
    }
    else if (new Date(value).toString() === "Invalid Date" && (typeof value) === 'string') {
      let valid = !value  ? true : (new Date(value.split(' ')[0]).toString() === "Invalid Date")
      if (valid) {
        return value;
      }else {
        let len = (value.split(' ')).length;
        let abbr = this.stringMdification(value, 2, len - 1).replace(abbreviation, (_, i) => i.toUpperCase());
        let date = this.stringMdification((new Date(value.split(' ')[0]) + ''), 1, 4);
        date = this.addingDecoration(date);
        let incoming = value.split(' ')[1] + ' ' + ' ' + abbr + ' ' + value.split(' ')[len - 1];
        
        const date2=value.split(' ')[0].split(/\//);
        let dd=timeZoneInd ?(date2[1]+'/'+date.split(' ')[0]+'/'+(date2[2])):(date.split(' ')[0]+'/'+date2[1]+'/'+(date2[2]));         
        return dd + " " + incoming;
      }
    }
    else {
      if (format === '24hrP'  && value ) {
        let date = this.stringMdification((new Date(value.split(' ')[0]) + ''), 1, 4);
        date = this.addingDecoration(date);
        let time = value.split(' ')[1]
        let timezone = value.split(' ')[2]
        let timezoneName = (value.split(' '))
          .slice(3)
          .reduce((a, b) => {
            let temp = a + ' '
            return temp.replace(/[()]/, "") + b.replace(/[()]/, "")
          }).replace(abbreviation, (_, i) => i.toUpperCase())

          const date2=value.split(' ')[0].split(/\//);
          let dd=timeZoneInd ?(date2[1]+'/'+date.split(' ')[0]+'/'+(date2[2])):(date.split(' ')[0]+'/'+date2[1]+'/'+(date2[2]));         
          return dd + " " + time + ' ' + " " + timezoneName + " " + '(' + timezone + ')';
        }
      else if (format === '24hr' && value ) {
        return moment(value)
        .format('MMM DD, YYYY - HH:mm A') +' GMT';
      } else if (format === '12hrz') {
        return moment.tz(value, 'America/Los_Angeles')
          .format('MMM DD, YYYY - hh:mm A zz');
      } else if (format === 'MMM DD,YYY z') {
        return moment(value)
          .format('MMM DD, YYYY - HH:mm A');
      }
    }
  }
}